import initFilters from './components/projects/filters';

const filtersEl = document.querySelector('.js-filters');

if (filtersEl) {
    initFilters(filtersEl);
}
